import {
  func,
  node,
  number,
  oneOf,
  oneOfType,
  shape,
  string,
} from "prop-types";

import classify from "web/classify";

import defaultClasses from "./selectItem.scss";

const SelectItem = ({ index, onSelect, children, classes, dataT1, dataT2 }) => {
  return (
    <li className={classes.root} data-t1={`${dataT1}_option`} data-t2={dataT2}>
      <button
        type="button"
        onClick={() => onSelect(index)}
        className={classes.button}
        data-t1={`${dataT1}_button`}
        data-t2={dataT2}
      >
        {children}
      </button>
    </li>
  );
};

SelectItem.propTypes = {
  index: oneOfType([number, shape({})]).isRequired,
  onSelect: oneOfType([func, oneOf([null])]),
  dataT1: string,
  dataT2: string,
  children: node,
  classes: shape({
    root: string,
  }),
};

SelectItem.defaultProps = {
  onSelect: null,
  dataT1: "select_item",
  dataT2: "",
  children: "",
  classes: {},
};

export default classify(defaultClasses)(SelectItem);
